import { useEffect, useRef } from "react";

export default function usePolling(callback, intervalMs = 15000, dependencies = []) {
  const cbRef = useRef(callback);
  const depsKey = JSON.stringify(dependencies);

  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);

  useEffect(() => {
    let timerId = null;

    const tick = async () => {
      if (document.visibilityState === "visible") {
        await cbRef.current();
      }
    };

    tick();
    timerId = setInterval(tick, intervalMs);
    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [intervalMs, depsKey]);
}
